import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
// import MainStyles from 'assets/styles/main.module.css';
import Styles from './Message.module.css';

const { Text } = Typography;

const propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  leftGutter: PropTypes.bool,
  className: PropTypes.string,
};

export const Message = memo(
  ({ children, type, leftGutter = true, className }) => {
    const renderIcon = useCallback(() => {
      if (type === 'success') {
        return <CheckCircleOutlined theme="outlined" className={Styles.icon} />;
      }
      if (type === 'error') {
        return <CloseCircleOutlined theme="filled" className={Styles.icon} />;
      }
      return <InfoCircleOutlined theme="filled" className={Styles.icon} />;
    }, [type]);
    return (
      <div
        className={clsx(
          Styles.messageWrapper,
          className,
          { [Styles.leftGutter]: leftGutter },
          Styles[`${type}`]
        )}
      >
        {renderIcon()}
        <Text className={Styles.text}>{children}</Text>
      </div>
    );
  }
);

Message.propTypes = propTypes;
